<template>
  <div class="box">
    <el-drawer :visible.sync="visible"
               :wrapperClosable="false"
               :show-close="false"
               :close-on-press-escape="false"
               custom-class="drawer1"
               :size="size">
      <div slot="title"
           style="border-bottom: 1px solid #ccc; padding-bottom: 10px">
        非手术项目救助拨款申请信息
        <div style="float: right">
          <i class="el-icon-question"></i>如何填写？
          <a href="javascript:;"
             style="color: #b60205; text-decoration: underline"
             @click="helpMe">查看示意图</a>
        </div>
      </div>

      <el-dialog :visible.sync="help_show"
                 width="80%"
                 append-to-body
                 title="众筹非手术项目救助拨款申请示意图">
        <img width="100%"
             src="../../../../assets/images/cfpro_pay_help2.png"
             alt />
      </el-dialog>

      <el-form :model="applyForm"
               :inline="true"
               :rules="rules1"
               ref="formRef"
               label-position="top"
               style="margin-bottom: 80px; padding: 0 20px">
        <el-row :gutter="20">
          <el-col :span="12">
            <!-- <el-form-item label="申请项目：">
              <el-input v-model="title" readonly disabled></el-input>
            </el-form-item> -->

            <!-- <el-form-item
              label="众筹项目"
              prop="project_id"
              v-if="this.$route.query.id && applyForm.project_name"
            >
              <el-input v-model="applyForm.project_name" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="众筹项目"
                          prop="project_id">
              <el-select v-model="applyForm.project_apply_id"
                         placeholder="请选择一个项目"
                         style="width: 100%"
                         :disabled="id > 0"
                         @change="projectChange"
                         :popper-append-to-body="false">
                <el-option v-for="item in projectList"
                           :key="item.project_apply_id"
                           :label="item.project_name"
                           :value="item.project_apply_id">
                  <span style="float: left">
                    {{ item.project_name }}（
                    <span style="color: red">{{ item.balance }}</span> 元）
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    item.apply_time
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="申请拨款金额：" prop="apply_money">
              <el-input v-model="applyForm.apply_money" readonly disabled></el-input>
            </el-form-item>-->
            <el-form-item label="项目负责人姓名"
                          prop="payee_rela_user_name">
              <el-input v-model="applyForm.payee_rela_user_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="收款单位名称"
                          prop="payee_unit_name">
              <el-input v-model="applyForm.payee_unit_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目负责人联系方式"
                          prop="payee_telephone">
              <el-input v-model="applyForm.payee_telephone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户行"
                          prop="bank_name">
              <el-input v-model="applyForm.bank_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户名"
                          prop="account_name">
              <el-input v-model="applyForm.account_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="银行卡号"
                          prop="account_number">
              <el-input v-model="applyForm.account_number"
                        :maxlength="25"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="费用组成单"
                          prop="costs"
                          style="width: 90%">
              <el-table :data="applyForm.costs"
                        border
                        show-summary
                        style="width: 100%"
                        :summary-method="getSummaries">
                <el-table-column prop="cost_item_name"
                                 label="物资名称"
                                 minWidth="200">
                  <template slot-scope="scope">
                    <el-input placeholder="请填写的物资名称"
                              v-model="applyForm.costs[scope.$index].cost_item_name"
                              style="width: 95%"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="unit_price"
                                 label="单价"
                                 width="200">
                  <template slot-scope="scope">
                    <el-input-number v-model="applyForm.costs[scope.$index].unit_price"
                                     placeholder="请填写的单价"
                                     controls-position="right"
                                     :precision="2"
                                     style="width: 95%"
                                     :min="0"
                                     :max="1000000"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column prop="number"
                                 label="数量"
                                 width="200">
                  <template slot-scope="scope">
                    <el-input placeholder="请填写的数量"
                              v-model.number="applyForm.costs[scope.$index].number"
                              style="width: 95%"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="total"
                                 sortable
                                 label="总额"
                                 width="200">
                  <template slot-scope="scope">
                    <el-input placeholder="自动计算"
                              disabled
                              v-model.number="applyForm.costs[scope.$index].total"
                              style="width: 95%"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center"
                                 width="100">
                  <template slot="header"
                            slot-scope="scope">
                    <el-button type="primary"
                               size="mini"
                               @click="addRow()">添加</el-button>
                  </template>
                  <template slot-scope="scope">
                    <el-button size="mini"
                               type="danger"
                               @click="delRow(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="el-icon-info">
                项目分配金额为：
                <span style="color: red">{{
                  setMoneyFormat(projectInfo.top_money)
                }}</span>
                元; 项目剩余金额为：
                <span style="color: red">{{
                  setMoneyFormat(projectInfo.balance)
                }}</span>
                元
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20"
                v-for="(item, index) in filesList"
                :key="'files' + index">
          <el-col>
            <el-form-item :label="item.text"
                          style="width: 80%"
                          :required="item.if_empty == 1">
              <el-upload :ref="'uploadFileRef' + index"
                         :action="uploadFileUrl"
                         :file-list="defFiles[index]"
                         :before-upload="beforeUploadFile"
                         :on-success="
                  (response, file, fileList) => {
                    handlerUpload(fileList, index, 'defFiles');
                  }
                "
                         :on-remove="
                  (file, fileList) => {
                    handlerUpload(fileList, index, 'defFiles');
                  }
                "
                         multiple>
                <el-button size="small"
                           type="primary">点击上传压缩文件</el-button>
              </el-upload>
              <div class="el-icon-info">
                请上传格式为rar或zip的文件，
                <span style="color: red">压缩文件必须包含：学生视力检查明细、项目照片</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="demo-drawer-footer">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-close"
                   @click="cancelBtn">关闭</el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-check"
                   @click="submitBtn"
                   :loading="loading">提交</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    size: {
      type: [String, Number],
      default: "85%",
    },
    id: {
      type: [String, Number],
      default: null,
    },
    // pid: {
    //   type: Number,
    //   default: null,
    // },
    // aid: {
    //   type: Number,
    //   default: null,
    // },
    // money: {
    //   type: [String, Number],
    //   default: 0,
    // },
  },
  data () {
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };

    var checkCosts = (rule, value, callback) => {
      let arr = [];
      if (typeof this.applyForm.costs === "undefined") {
        return callback(new Error("请填写费用组成单！"));
      } else {
        if (this.applyForm.costs.length === 0) {
          return callback(new Error("请填写费用组成单！"));
        } else {
          this.applyForm.costs.forEach((item, index) => {
            let num = index + 1;
            if (!item.cost_item_name) {
              return callback(new Error("请填写" + num + "条信息物资名称"));
            } else if (!(item.number > 0)) {
              return callback(new Error("请选择" + num + "条数量"));
            } else if (!(item.unit_price > 0)) {
              return callback(new Error("请填写" + num + "条单价"));
            } else if (item.number > 0 && item.unit_price > 0) {
              item.total = item.number * item.unit_price;
            }
          });
        }
      }
      return callback();
    };

    return {
      help_show: false,
      visible: false,
      loading: false,
      money_text: null,
      filesList: [], //明细化附件集
      projectList: [],
      projectInfo: { top_money: null, balance: null },
      defFiles: [], //
      files: [], //
      applyForm: { apply_money: null, costs: [] },
      rules1: {
        // apply_user_name: [
        //   { required: true, message: "请输入申请人姓名", trigger: "blur" }
        // ],
        payee_unit_name: [
          { required: true, message: "请输入收款单位名称", trigger: "blur" },
        ],
        payee_rela_user_name: [
          {
            required: true,
            message: "请输入项目负责人姓名！",
            trigger: "blur",
          },
        ],
        // payee_office_phone: [
        //   { required: true, message: "请输入单位联系座机", trigger: "blur" }
        // ],
        payee_telephone: [
          {
            required: true,
            message: "请输入项目负责人联系方式！",
            trigger: "blur",
          },
          { validator: checkPhone, trigger: "blur" },
        ],
        bank_name: [
          { required: true, message: "请输入收款开户行", trigger: "blur" },
        ],
        account_name: [
          { required: true, message: "请输入收款开户名", trigger: "blur" },
        ],
        account_number: [
          { required: true, message: "请输入收款银行卡号", trigger: "blur" },
        ],
        // payment_reason: [
        //   { required: true, message: "请输入申请理由", trigger: "blur" }
        // ]
        costs: [
          {
            required: true,
            message: "请添加费用组成单信息",
            trigger: "change",
            type: "array",
          },
          { validator: checkCosts, trigger: "change" },
        ],
      },
    };
  },

  methods: {
    //示意图操作
    helpMe () {
      this.help_show = true;
    },

    //项目选择
    projectChange (val) {
      this.projectInfo = val
        ? this.projectList.find((it) => it.project_apply_id === val)
        : {};
    },

    getProjectList () {
      //获取可申请的简单众筹项目列表
      return this.$db.post(this.$db.config.getApplyComprojectList, {
        project_type: 2,
      });
    },

    handlerUpload (fileList, index, name) {
      this.$set(this[name], index, []);
      this.$set(this[name], index, fileList);
    },

    cancelBtn () {
      this.visible = false;
    },

    //计算表格合计
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (index === 4 || index == 1 || index == 2) {
          return "";
        }

        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "N/A";
        }
      });

      if (sums[3] > 0) {
        let num = Number(this.projectInfo.balance);
        // if (this.id > 0) {
        //   num = Number(this.projectInfo.balance) + Number(this.applyForm.apply_money)
        // }

        if (sums[3] > num) {
          this.applyForm.apply_money = null;
          sums[3] =
            "申请总额：" +
            this.setMoneyFormat(sums[3]) +
            " 元，已超出分配金额！";
        } else {
          this.applyForm.apply_money = sums[3];
          sums[3] = "申请总额：" + this.setMoneyFormat(sums[3]) + " 元";
        }
      }

      // if (sums[1] > 0) {
      //   sums[1] = "平均值：" + sums[1] / data.length;
      // }
      // if (sums[2] > 0) {
      //   sums[2] = "总数：" + this.setMoneyFormat(sums[2]);
      // }

      return sums;
    },

    //千分化金额
    setMoneyFormat (num) {
      if (num) {
        let value = typeof num === "number" ? num : Number(num);
        return (value.toFixed(2) + "").replace(
          /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
          "$&,"
        );
      }
    },

    //计算费用组成单总额
    calcTotal (index) {
      //小数点丢失精度处理
      if (
        this.applyForm.costs[index].number > 0 &&
        this.applyForm.costs[index].unit_price
      ) {
        this.applyForm.costs[index].total = this.numMulti(
          this.applyForm.costs[index].number,
          this.applyForm.costs[index].unit_price
        );
      } else {
        this.applyForm.costs[index].total = null;
      }
    },

    //处理乘法丢失精度问题
    numMulti (num1, num2) {
      var baseNum = 0;
      try {
        baseNum += num1.toString().split(".")[1].length;
      } catch (e) { }
      try {
        baseNum += num2.toString().split(".")[1].length;
      } catch (e) { }
      return (
        (Number(num1.toString().replace(".", "")) *
          Number(num2.toString().replace(".", ""))) /
        Math.pow(10, baseNum)
      );
    },

    //费用组成单 增加列
    addRow () {
      let temp = {
        cost_item_name: null,
        unit_price: null,
        number: null,
        total: null,
      };

      let len = this.applyForm.costs.length;
      if (len > 0) {
        let info = this.applyForm.costs[len - 1];
        if (
          !(
            info.cost_item_name &&
            info.unit_price > 0 &&
            info.number > 0 &&
            info.total
          )
        ) {
          return this.$message.warning("请先完善上一行费用组成单信息！");
        }
      }

      this.applyForm.costs.push(temp);
    },

    //费用组成单 删除列
    delRow (index, row) {
      this.applyForm.costs.splice(index, 1);
    },

    //获取附件集
    getFilesList () {
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100360,
          remark: "if_empty",
          table: "pub_type_param",
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.filesList = res.data;
          }
        });
    },

    beforeUploadFile (file) {
      let bool = this.$fnc.checkUploadFile(file, ["zip", "rar"]);
      return bool;
    },

    getLastInfo (id) {
      //获取上一次的信息
      this.$db
        .post(this.$db.config.getcfProLastPayApplyInfo, { apply_id: id })
        .then((res) => {
          if (res.code == 200) {
            this.applyForm.pics = [];
            this.applyForm.files = [];
            this.applyForm = res.data;
            let arr = [];
            if (res.data.files_details && res.data.files_details.length > 0) {
              res.data.files_details.forEach((item, key) => {
                arr.push(item.files_path);
              });
            }

            this.defFiles = arr;
          }
        });
    },

    //获取编辑信息
    getEditInfo (id) {
      this.$db
        .post(this.$db.config.getCfProPayApplyInfo, { id: id })
        .then((res) => {
          if (res && res.code == 200) {
            this.applyForm = res.data;
            let arr = [];
            this.projectChange(res.data.project_apply_id);

            if (res.data.files_details.length) {
              res.data.files_details.forEach((item, key) => {
                arr.push(item.files_path);
              });
              this.defFiles = arr;
            }
          }
        });
    },

    //提交拨款申请
    submitBtn () {
      this.files = [];

      //处理批量附件集
      for (const [key, val] of this.filesList.entries()) {
        let cur = this.defFiles[key];
        if (cur && cur.length > 0) {
          let temp = {
            dict_id: val.value,
            files_id: [],
            if_empty: val.if_empty,
          };
          for (const item of cur) {
            if (item.hasOwnProperty("response")) {
              temp.files_id.push(item.response.data.id);
            } else {
              temp.files_id.push(item.id);
            }
          }
          this.files.push(temp);
        } else {
          if (val.if_empty == 1) {
            this.$message.warning(val.text + "不能为空！");
            return;
          }
        }
      }

      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          if (!(this.applyForm.apply_money > 0)) {
            this.$message.warning("申请总额填写有误！");
            return false;
          }

          this.applyForm.project_apply_id = this.projectInfo.project_apply_id;
          this.applyForm.project_id = this.projectInfo.id;

          let url;
          if (this.id > 0) {
            url = this.$db.config.updateCfProPayApplyInfo;
          } else {
            url = this.$db.config.submitCfProPayApplyInfo;
          }
          this.loading = true;
          this.applyForm.files = this.files;

          this.$db.post(url, this.applyForm).then((res) => {
            this.loading = false;
            if (res && res.code == 200) {
              this.$message.success(res.msg);
              this.cancelBtn();
              this.$emit("success", "2");
            }
          });
        } else {
          this.loading = false;
          return this.$message.warning("请填写完整信息！");
        }
      });
    },
  },
  watch: {
    visible (val) {
      this.$emit("input", val);
    },

    value: {
      handler (val) {
        this.visible = val;
      },
      immediate: true,
    },
  },
  async created () {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.getFilesList();
    let res = await this.getProjectList();
    this.projectList = res.data;
    if (this.id > 0) {
      //编辑操作
      this.getEditInfo(this.id);
    } else {
      // this.getLastInfo(this.id);
    }
  },
};
</script>
<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.el-form-item {
  width: 90%;
}

.demo-drawer-footer {
  width: 85%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/appropriation/info2.vue